import type { RecommendedActionCode } from "../types";

/** Marked nodes the player has not chosen a measure for; the map cannot be submitted while any remain. */
export function markedWithoutMeasure(
  marked: ReadonlySet<string>,
  measures: Readonly<Record<string, RecommendedActionCode>>,
): string[] {
  return [...marked].filter((id) => !measures[id]);
}
